/* eslint-disable */
// ARQUIVO GERADO — não edite à mão.
// Gerado por scripts/generate-api-catalog.mjs a partir do OpenAPI do mk-ms-tenant-cross.
// Fonte: http://localhost:8095/mk-ms-tenant-cross/api-docs/json
// Para atualizar: rode o script apontando para o /api-docs/json do ambiente.
//
// A seção 'partner' (/integrations) NÃO está aqui — é curada à mão em apiCatalog.ts.

import { ApiEndpoint } from './apiTypes';

export const INTERNAL_ENDPOINTS: ApiEndpoint[] = [
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions",
    "summary": "Find All — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "query": [
      {
        "name": "id_tag",
        "description": ""
      },
      {
        "name": "environment_not_included",
        "description": ""
      },
      {
        "name": "only_finished",
        "description": ""
      },
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId",
    "summary": "Find By Id — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/device",
    "summary": "Detail — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/feedback",
    "summary": "Find By Id — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/invoice-data",
    "summary": "Get — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/meter",
    "summary": "Find By Id — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/payment",
    "summary": "Detail — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "PUT",
    "path": "/transactions/:transactionId/payment",
    "summary": "Update — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"transaction_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"error\": \"string\",\n  \"paid_timestamp\": \"string\",\n  \"transaction_amount\": 0,\n  \"transaction_amount_refunded\": 0,\n  \"type\": \"string\",\n  \"external_id\": \"string\",\n  \"external_token\": \"string\",\n  \"installments\": 0,\n  \"status\": \"APPROVED\",\n  \"status_detail\": \"string\",\n  \"invoice_data\": {\n    \"legal_name\": \"string\",\n    \"company_tax_id\": \"string\",\n    \"state_registration\": \"string\",\n    \"email\": \"string\",\n    \"address\": {\n      \"street\": \"string\",\n      \"number\": 0,\n      \"neighborhood\": \"string\",\n      \"complement\": \"string\",\n      \"city\": \"string\",\n      \"state\": \"string\",\n      \"country\": \"string\",\n      \"postal_code\": \"string\"\n    }\n  }\n}"
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "PATCH",
    "path": "/transactions/:transactionId/payment/approve",
    "summary": "Approve — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"transaction_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"error\": \"string\",\n  \"paid_timestamp\": \"string\",\n  \"transaction_amount\": 0,\n  \"status\": \"APPROVED\",\n  \"payment_type\": \"string\"\n}"
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:transactionId/tariff",
    "summary": "Detail — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "transactionId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:userId/:chargeBoxId/totalizer",
    "summary": "Find By Id — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "userId",
        "description": ""
      },
      {
        "name": "chargeBoxId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Transactions",
    "method": "GET",
    "path": "/transactions/:userUuid/open-payments",
    "summary": "Get Open Payments — Transactions (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "userUuid",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants",
    "summary": "List — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "canTenantBind",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId",
    "summary": "Detail — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/bind-audit",
    "summary": "Search — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "eventTypes",
        "description": ""
      },
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "from",
        "description": ""
      },
      {
        "name": "to",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/bind-audit/export",
    "summary": "Export Csv — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "eventTypes",
        "description": ""
      },
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "from",
        "description": ""
      },
      {
        "name": "to",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/connections",
    "summary": "List — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/cross-transactions",
    "summary": "Search — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "chargeBoxId",
        "description": ""
      },
      {
        "name": "paymentStatus",
        "description": ""
      },
      {
        "name": "from",
        "description": ""
      },
      {
        "name": "to",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/cross-transactions/export",
    "summary": "Export Csv — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "chargeBoxId",
        "description": ""
      },
      {
        "name": "paymentStatus",
        "description": ""
      },
      {
        "name": "from",
        "description": ""
      },
      {
        "name": "to",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/cross-transactions/totals",
    "summary": "Totals — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "chargeBoxId",
        "description": ""
      },
      {
        "name": "paymentStatus",
        "description": ""
      },
      {
        "name": "from",
        "description": ""
      },
      {
        "name": "to",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/integration-stations",
    "summary": "Search — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "search",
        "description": ""
      },
      {
        "name": "direction",
        "description": ""
      },
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "registration",
        "description": ""
      },
      {
        "name": "issue",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/integration-stations/:chargeBoxId",
    "summary": "Detail — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "chargeBoxId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/integration-stations/totals",
    "summary": "Totals — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "search",
        "description": ""
      },
      {
        "name": "direction",
        "description": ""
      },
      {
        "name": "partnerTenantId",
        "description": ""
      },
      {
        "name": "registration",
        "description": ""
      },
      {
        "name": "issue",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/integration-tokens",
    "summary": "List — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/integration-tokens",
    "summary": "Create — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"name\": \"string\",\n  \"scopes\": [\n    \"READ\"\n  ],\n  \"contact_email\": \"string\",\n  \"expires_at\": \"2026-01-01T00:00:00Z\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantId/integration-tokens/:tokenId",
    "summary": "Revoke — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "tokenId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantId/integration-tokens/:tokenId/permanent",
    "summary": "Delete Permanently — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "tokenId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/integration-tokens/:tokenId/recreate",
    "summary": "Recreate — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "tokenId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/integration-tokens/:tokenId/renew",
    "summary": "Renew — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "tokenId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "PUT",
    "path": "/tenants/:tenantId/integration-tokens/:tokenId/validity",
    "summary": "Extend Validity — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "tokenId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"expires_at\": \"2026-01-01T00:00:00Z\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/invites",
    "summary": "History — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "direction",
        "description": ""
      },
      {
        "name": "status",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/invites",
    "summary": "Generate — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"tenant_source_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"partner_share_token\": \"string\",\n  \"tenant_target_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"contact_email\": \"string\",\n  \"contract_type\": \"UNILATERAL\",\n  \"ttl\": \"MIN_15\",\n  \"created_by\": \"string\",\n  \"scope_mode\": \"ALL\",\n  \"scope_selection\": [\n    \"00000000-0000-4000-8000-000000000000\"\n  ],\n  \"inherits_new_subaccounts\": false\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantId/invites/:inviteId",
    "summary": "Revoke — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "inviteId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/invites/:inviteId/accept",
    "summary": "Accept By Id — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "inviteId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantId/invites/:inviteId/permanent",
    "summary": "Delete Permanently — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      },
      {
        "name": "inviteId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/invites/accept",
    "summary": "Accept — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"token\": \"string\",\n  \"actor\": \"string\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/invites/received",
    "summary": "Received — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/invites/sent",
    "summary": "Sent — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/invites/validate",
    "summary": "Validate — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"token\": \"string\",\n  \"actor\": \"string\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantId/share-token",
    "summary": "Current — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/share-token",
    "summary": "Generate — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"ttl\": \"NEVER\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantId/share-token/resolve",
    "summary": "Resolve — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"token\": \"string\"\n}"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantSourceId/binds",
    "summary": "List — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      },
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId",
    "summary": "Delete — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId",
    "summary": "Add — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/contract",
    "summary": "Delete Revoked Contract — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/reactivate",
    "summary": "Reactivate — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "PUT",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/received-visibility",
    "summary": "Set Received Visibility — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "visible",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/revoke",
    "summary": "Revoke Contract — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/scope",
    "summary": "Scope — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "PUT",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/scope",
    "summary": "Change Scope — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ],
    "bodyExample": "[\n  \"00000000-0000-4000-8000-000000000000\"\n]"
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantSourceId/binds/:tenantTargetId/suspend",
    "summary": "Suspend — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      },
      {
        "name": "tenantTargetId",
        "description": ""
      }
    ],
    "headers": [
      {
        "name": "X-Actor",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantSourceId/binds/accounts",
    "summary": "Accounts — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "DELETE",
    "path": "/tenants/:tenantSourceId/binds/all",
    "summary": "Delete All — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "POST",
    "path": "/tenants/:tenantSourceId/binds/all",
    "summary": "Add All — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantSourceId/binds/map",
    "summary": "Map — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tenants",
    "method": "GET",
    "path": "/tenants/:tenantSourceId/binds/sources",
    "summary": "Find Source External Ids — Tenants (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "tenantSourceId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "GET",
    "path": "/charge-boxs",
    "summary": "List — Charge Boxs (tenant-cross internal API)",
    "auth": "TENANT_ID",
    "query": [
      {
        "name": "tenant_external_id",
        "description": ""
      },
      {
        "name": "location_latitude",
        "description": ""
      },
      {
        "name": "location_longitude",
        "description": ""
      },
      {
        "name": "max_distance",
        "description": ""
      },
      {
        "name": "environment_not_included",
        "description": ""
      },
      {
        "name": "qrcode_link",
        "description": ""
      },
      {
        "name": "charge_box_number",
        "description": ""
      },
      {
        "name": "is_ocpi",
        "description": ""
      },
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      }
    ],
    "headers": [
      {
        "name": "X-TENANT-ID",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "GET",
    "path": "/charge-boxs/:chargeBoxId",
    "summary": "Detail By Charge Box Id — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "chargeBoxId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "GET",
    "path": "/charge-boxs/:chargeBoxId/photos",
    "summary": "All — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "chargeBoxId",
        "description": ""
      }
    ],
    "query": [
      {
        "name": "page",
        "description": "Zero-based page index (0..N)"
      },
      {
        "name": "size",
        "description": "The size of the page to be returned"
      },
      {
        "name": "sort",
        "description": "Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported."
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "PUT",
    "path": "/charge-boxs/:connectorId/start",
    "summary": "Command Start — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "connectorId",
        "description": ""
      }
    ],
    "bodyExample": "{\n  \"transaction_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"connector_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"tenant_app\": {\n    \"tenant_id\": \"00000000-0000-4000-8000-000000000000\"\n  },\n  \"id_tag\": \"string\",\n  \"user_id\": \"00000000-0000-4000-8000-000000000000\",\n  \"km_kwh\": 0,\n  \"payment\": {\n    \"type\": \"string\",\n    \"external_id\": \"string\",\n    \"external_token\": \"string\",\n    \"installments\": 0,\n    \"reserved_amount\": 0\n  },\n  \"device\": {\n    \"operational_system\": \"string\",\n    \"serial\": \"string\",\n    \"model\": \"string\",\n    \"location_latitude\": 0,\n    \"location_longitude\": 0,\n    \"resolution\": \"string\",\n    \"ram\": \"string\"\n  },\n  \"origin\": \"string\",\n  \"webhook\": {\n    \"id\": \"00000000-0000-4000-8000-000000000000\",\n    \"url\": \"string\",\n    \"headers\": {}\n  },\n  \"error_code\": \"string\",\n  \"kwh_target\": 0\n}"
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "PUT",
    "path": "/charge-boxs/:connectorId/stop",
    "summary": "Command Stop — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "connectorId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "GET",
    "path": "/charge-boxs/number",
    "summary": "Detail By Number — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "query": [
      {
        "name": "tenant_id",
        "description": ""
      },
      {
        "name": "tenant_external_id",
        "description": ""
      },
      {
        "name": "location_latitude",
        "description": ""
      },
      {
        "name": "location_longitude",
        "description": ""
      },
      {
        "name": "max_distance",
        "description": ""
      },
      {
        "name": "charge_box_number",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Charge Boxs",
    "method": "GET",
    "path": "/charge-boxs/qrcode",
    "summary": "Detail By Qrcode Link — Charge Boxs (tenant-cross internal API)",
    "auth": "SESSION",
    "query": [
      {
        "name": "qrcode_link",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tariffs",
    "method": "GET",
    "path": "/charge-boxs/:chargeBoxId/tariff",
    "summary": "Detail — Tariffs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "chargeBoxId",
        "description": ""
      }
    ]
  },
  {
    "section": "internal",
    "group": "Tariffs",
    "method": "GET",
    "path": "/charge-boxs/connector/:connectorId/tariff",
    "summary": "Detail — Tariffs (tenant-cross internal API)",
    "auth": "SESSION",
    "pathParams": [
      {
        "name": "connectorId",
        "description": ""
      }
    ]
  }
];
